import { Box, Paper, Typography, TextField } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { useState } from "react";
import PMButton from '../common/Button';
import { useDispatch, useSelector } from 'react-redux'
import { changePassword } from "../../actions/auth";
import PasswordValidator from "../common/PasswordValidator";
import { warning } from "../../utils/SnackBar";
import { passwordConditions, updatePasswordFieldConditions } from "../../utils/utilFunctions";

const useStyles = makeStyles((theme) => ({
    subHeader: { fontSize: 18, fontWeight: 600, color: "#243247" },
    root: { display: "flex", flexDirection: "column", marginTop: theme.spacing(2) },
    paper: {
        height: "100%", boxSizing: "border-box", padding: theme.spacing(4),
        borderRadius: 16, border: "1px solid #e3e9f0", boxShadow: "0 3px 14px rgba(30, 50, 80, 0.04)",
    },
    profileField: {
        marginTop: theme.spacing(1), marginBottom: theme.spacing(1.5),
        '& .MuiOutlinedInput-root': { borderRadius: 10 },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: "#dce3ec" },
    },
    input: { fontSize: 14 },
    button: { '&&': { borderRadius: 10, width: "auto", minWidth: 180, height: 44, fontSize: 14, padding: theme.spacing(0, 3) } },
    buttonContainer: { display: "flex", justifyContent: "flex-end", marginTop: theme.spacing(1) },

  }));


const ChangePassword = () => {

    const classes = useStyles();
    const dispatch = useDispatch()

    const loading = useSelector((state) => state.auth.loading)

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [conditions, setConditions] = useState(passwordConditions)

    const handleSetCurrentPassword = (e) => {
        setConditions(updatePasswordFieldConditions(conditions, "CURRENT_PASSWORD", newPassword, confirmNewPassword, e.target.value))
        setCurrentPassword(e.target.value)
    }

    const handleSetNewPassword = (e) => {
        setConditions(updatePasswordFieldConditions(conditions, "NEW_PASSWORD", e.target.value, confirmNewPassword, currentPassword))
        setNewPassword(e.target.value)
    }

    const handleSetConfirmPassword = (e) => {
        setConditions(updatePasswordFieldConditions(conditions, "CONFIRM_PASSWORD", newPassword, e.target.value, currentPassword))
        setConfirmNewPassword(e.target.value)
    }

    const handleChangePassword = (e) => {
        if(Object.values(conditions).every((condition) => condition.state)) {
            dispatch(changePassword(currentPassword, newPassword, confirmNewPassword))
            setCurrentPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
            setConditions(passwordConditions)
        } else {
            warning("All conditions must be met before changing password.")
        }
    }

    return (
            <Paper className={classes.paper} elevation={0}>
                <Typography align = "left" className = {classes.subHeader} variant="h6" gutterBottom>
                    Change Your Password
                </Typography>
                <Typography variant="body2" color="textSecondary">Keep your account secure with a strong password.</Typography>
            <Box className={classes.root}>
                <TextField 
                    className = {classes.profileField} 
                    InputLabelProps= {{className: classes.input}}
                    InputProps={{className: classes.input}} 
                    type = "password"
                    variant = "outlined"
                    label="Current Password"
                    value={currentPassword}
                    onChange={(e) => {handleSetCurrentPassword(e)}}
                />
                <TextField 
                    className = {classes.profileField}
                    InputLabelProps= {{className: classes.input}}
                    InputProps={{className: classes.input}}
                    type = "password"
                    variant = "outlined"
                    label="New Password"
                    value={newPassword}
                    onChange={(e) => {handleSetNewPassword(e)}}
                />
                <TextField
                    className = {classes.profileField}
                    InputLabelProps= {{className: classes.input}}
                    InputProps={{className: classes.input}}
                    type = "password"
                    variant = "outlined"
                    label="Confirm New Password"
                    value={confirmNewPassword}
                    onChange={(e) => {handleSetConfirmPassword(e)}}
                />
                {(currentPassword !== "" || newPassword !== "" || confirmNewPassword !== "") && (
                    <PasswordValidator
                        conditions={conditions}
                    />
                )}
                <Box className={classes.buttonContainer}>
                    <PMButton loading={loading} disabled={loading} className={classes.button} type="submit" onClick={handleChangePassword}>
                        Change Password
                    </PMButton>
                </Box>
            </Box>
            </Paper>
    );
}

export default ChangePassword;